/*eslint default-case: "off"*/
import firebase from 'firebase/app';
import 'firebase/firestore';
import { JoyAuthServiceAuthProvider, JoyDataServiceAction, JoyField, JoyObjectType, JoyChangeType, JoyUserRole, JoyActivityEvent, JoyCommentType, JoyUploadSessionType, JoyUploadSessionStatus, JoyUploadServiceAction, JoyProperty, JoyStatus, isJoyFieldMapArray, isJoyUploadSessionType, isJoyUploadSessionStatusArray, isJoyUserRoleMap, isJoyPropertiesArray, isNumber, isString, isStringArray, isStringMap, isStringMapArray, isBoolean, isDate, } from 'joy-core';
import { JoyCrmIntegrationServiceFunction } from 'joy-crm';
import { isTimestamp, isDocumentReference } from './DataValidation';
export function fromFirestore(data, id) {
    let output = new Map();
    if (isStringMap(data['album'])) {
        output[JoyField.album] = fromFirestore(data['album']);
    }
    if (isStringArray(data['albums'])) {
        output[JoyField.albums] = data['albums'];
    }
    if (isTimestamp(data['birthday'])) {
        output[JoyField.birthday] = data['birthday'].toDate();
    }
    else if (isStringMap(data['birthday'])) {
        let date = fromFirestoreDate(data['birthday']);
        if (isDate(date)) {
            output[JoyField.birthday] = date;
        }
    }
    if (isNumber(data['blue'])) {
        output[JoyField.blue] = data['blue'];
    }
    if (isStringMap(data['comment'])) {
        output[JoyField.comment] = fromFirestore(data['comment']);
    }
    if (isStringMapArray(data['recentComments'])) {
        let comments = [];
        for (const commentData of data['recentComments']) {
            comments.push(fromFirestore(commentData));
        }
        output[JoyField.comments] = comments;
    }
    if (isString(data['type'])) {
        output[JoyField.commentType] = fromFirestoreCommentType(data['type']);
    }
    if (isString(data['content'])) {
        output[JoyField.content] = data['content'];
    }
    if (isNumber(data['commentsCount'])) {
        output[JoyField.count] = data['commentsCount'];
    }
    if (isString(data['countryCode'])) {
        output[JoyField.countryCode] = data['countryCode'];
    }
    if (isNumber(data['mediaCount'])) {
        output[JoyField.count] = data['mediaCount'];
    }
    else if (isNumber(data['length'])) {
        output[JoyField.count] = data['length'];
    }
    if (isString(data['contact'])) {
        output[JoyField.contact] = data['contact'];
    }
    if (isStringMap(data['coverMedia'])) {
        output[JoyField.coverMedium] = fromFirestore(data['coverMedia']);
    }
    if (isTimestamp(data['createdAt'])) {
        output[JoyField.createdAt] = data['createdAt'].toDate();
    }
    else if (isStringMap(data['createdAt'])) {
        let date = fromFirestoreDate(data['createdAt']);
        if (isDate(date)) {
            output[JoyField.createdAt] = date;
        }
    }
    else if (isString(data['created_at'])) {
        output[JoyField.createdAt] = new Date(data['created_at']);
    }
    if (isDocumentReference(data['createdBy'])) {
        output[JoyField.createdBy] = data['createdBy'].id;
    }
    else if (isString(data['createdBy'])) {
        output[JoyField.createdBy] = data['createdBy'];
    }
    if (isStringMapArray(data['searchedData'])) {
        let result = [];
        for (const elementData of data['searchedData']) {
            let element = new Map();
            if (isStringMap(elementData['contact'])) {
                element[JoyField.user] = fromFirestore(elementData['contact']);
            }
            if (isStringMap(elementData['deal'])) {
                element[JoyField.data] = fromFirestore(elementData['deal']);
            }
            if (isString(elementData['stageTag'])) {
                element[JoyField.status] = elementData['stageTag'];
            }
            result.push(element);
        }
        output[JoyField.data] = result;
    }
    if (isString(data['dealId'])) {
        output[JoyField.deal] = data['dealId'];
    }
    if (isString(data['description'])) {
        output[JoyField.description] = data['description'];
    }
    if (isString(data['firestoreId'])) {
        output[JoyField.objectId] = data['firestoreId'];
    }
    if (isString(data['fileUrl'])) {
        output[JoyField.downloadUri] = data['fileUrl'];
    }
    if (isNumber(data['duration'])) {
        output[JoyField.duration] = data['duration'];
    }
    if (isString(data['email'])) {
        output[JoyField.email] = data['email'];
    }
    if (isStringArray(data['emails'])) {
        output[JoyField.emails] = data['emails'];
    }
    else if (isStringMapArray(data['failedEmails'])) {
        let emails = [];
        for (const emailData of data['failedEmails']) {
            emails.push(fromFirestore(emailData));
        }
        output[JoyField.emails] = emails;
    }
    if (isString(data['event'])) {
        output[JoyField.event] = fromFirestoreActivityEvent(data['event']);
    }
    if (isBoolean(data['exists'])) {
        output[JoyField.exists] = data['exists'];
    }
    if (isString(data['firstName'])) {
        output[JoyField.firstName] = data['firstName'];
    }
    if (isNumber(data['green'])) {
        output[JoyField.green] = data['green'];
    }
    if (isStringMap(data['group'])) {
        output[JoyField.group] = fromFirestore(data['group']);
    }
    else if (isString(data['groupId'])) {
        output[JoyField.group] = data['groupId'];
    }
    if (isStringArray(data['groups'])) {
        output[JoyField.groups] = data['groups'];
    }
    else if (isStringMap(data['groups'])) {
        let groups = new Map();
        for (const key in data['groups']) {
            groups[key] = fromFirestoreRole(data['groups'][key]);
        }
        output[JoyField.groups] = groups;
    }
    if (isNumber(data['height'])) {
        output[JoyField.height] = data['height'];
    }
    if (isString(id)) {
        output[JoyField.id] = id;
    }
    else if (isString(data['id'])) {
        output[JoyField.id] = data['id'];
    }
    if (isBoolean(data['isAnonymous'])) {
        output[JoyField.isAnonymous] = data['isAnonymous'];
    }
    if (isBoolean(data['isPublic'])) {
        output[JoyField.isPublic] = data['isPublic'];
    }
    if (isString(data['lastName'])) {
        output[JoyField.lastName] = data['lastName'];
    }
    if (isStringArray(data['likes'])) {
        output[JoyField.likes] = data['likes'];
    }
    if (isStringMap(data['meanColor'])) {
        output[JoyField.meanColor] = fromFirestore(data['meanColor']);
    }
    if (isStringArray(data['media'])) {
        output[JoyField.mediums] = data['media'];
    }
    else if (isStringMapArray(data['media'])) {
        let mediums = [];
        for (const mediumData of data['media']) {
            mediums.push(fromFirestore(mediumData));
        }
        output[JoyField.mediums] = mediums;
    }
    if (isStringMap(data['medium'])) {
        output[JoyField.medium] = fromFirestore(data['medium']);
    }
    else if (isString(data['mediumId'])) {
        output[JoyField.medium] = data['mediumId'];
    }
    if (isString(data['mimeType'])) {
        output[JoyField.mimeType] = data['mimeType'];
    }
    if (isString(data['name'])) {
        output[JoyField.name] = data['name'];
    }
    else if (isString(data['title'])) {
        output[JoyField.name] = data['title'];
    }
    if (isBoolean(data['hasPassword'])) {
        output[JoyField.password] = data['hasPassword'];
    }
    if (isString(data['phone'])) {
        output[JoyField.phone] = data['phone'];
    }
    if (isString(data['photoUrl'])) {
        output[JoyField.photoUrl] = data['photoUrl'];
    }
    if (isString(data['primaryEmail'])) {
        output[JoyField.primaryEmail] = data['primaryEmail'];
    }
    if (isStringArray(data['props'])) {
        let properties = [];
        for (const propData of data['props']) {
            properties.push(fromFirestoreProperty(propData));
        }
        output[JoyField.props] = properties;
    }
    if (isString(data['reason'])) {
        output[JoyField.reason] = data['reason'];
    }
    if (isNumber(data['red'])) {
        output[JoyField.red] = data['red'];
    }
    if (isString(data['sessionType'])) {
        output[JoyField.sessionType] = fromFirestoreSessionType(data['sessionType']);
    }
    if (isStringMap(data['source'])) {
        output[JoyField.source] = fromFirestore(data['source']);
    }
    if (isString(data['sessionStatus'])) {
        output[JoyField.status] = fromFirestoreSessionStatus(data['sessionStatus']);
    }
    else if (isString(data['status'])) {
        output[JoyField.status] = fromFirestoreStatus(data['status']);
    }
    if (isNumber(data['storageUsed'])) {
        output[JoyField.storageUsed] = data['storageUsed'];
    }
    if (isString(data['hls'])) {
        output[JoyField.streamUriHls] = data['hls'];
    }
    if (isString(data['mpd'])) {
        output[JoyField.streamUriMpd] = data['mpd'];
    }
    if (isString(data['thumbFileUrl'])) {
        output[JoyField.thumbnailUri] = data['thumbFileUrl'];
    }
    if (isStringMap(data['invitedUser'])) {
        output[JoyField.user] = fromFirestore(data['invitedUser']);
    }
    else if (isString(data['userId'])) {
        output[JoyField.user] = data['userId'];
    }
    else if (isString(data['owner'])) {
        output[JoyField.user] = data['owner'];
    }
    if (isStringMapArray(data['failedRemoves'])) {
        let users = [];
        for (const userData of data['failedRemoves']) {
            users.push(fromFirestore(userData));
        }
        output[JoyField.users] = users;
    }
    else if (isStringArray(data['users'])) {
        output[JoyField.users] = data['users'];
    }
    if (isStringMapArray(data['activeClients'])) {
        let users = [];
        for (const userData of data['activeClients']) {
            users.push(fromFirestore(userData));
        }
        output[JoyField.usersActive] = users;
    }
    if (isStringMapArray(data['inactiveClients'])) {
        let users = [];
        for (const userData of data['inactiveClients']) {
            users.push(fromFirestore(userData));
        }
        output[JoyField.usersInactive] = users;
    }
    if (isNumber(data['width'])) {
        output[JoyField.width] = data['width'];
    }
    return output;
}
export function toFirestore(data) {
    let output = new Map();
    if (isString(data[JoyField.album])) {
        output['albumId'] = data[JoyField.album];
    }
    if (isStringArray(data[JoyField.albums])) {
        output['albums'] = data[JoyField.albums];
    }
    if (isDate(data[JoyField.birthday])) {
        output['birthday'] = toFirestoreDate(data[JoyField.birthday]);
    }
    if (isString(data[JoyField.content])) {
        output['content'] = data[JoyField.content];
    }
    if (isNumber(data[JoyField.count])) {
        output['mediaCount'] = data[JoyField.count];
    }
    if (isString(data[JoyField.coverMedium])) {
        output['cover'] = data[JoyField.coverMedium];
    }
    if (isString(data[JoyField.description])) {
        output['description'] = data[JoyField.description];
    }
    if (isNumber(data[JoyField.duration])) {
        output['duration'] = data[JoyField.duration];
    }
    if (isString(data[JoyField.email])) {
        output['email'] = data[JoyField.email];
    }
    if (isStringArray(data[JoyField.emails])) {
        output['emails'] = data[JoyField.emails];
    }
    if (isString(data[JoyField.group])) {
        output['groupId'] = data[JoyField.group];
    }
    let groups = data[JoyField.groups];
    if (isStringArray(groups)) {
        output['groups'] = groups;
    }
    else if (isJoyUserRoleMap(groups)) {
        let fsGroups = {};
        groups.forEach((value, key) => {
            fsGroups[key] = toFirestoreRole(value);
        });
        output['groups'] = fsGroups;
    }
    if (isString(data[JoyField.id])) {
        output['id'] = data[JoyField.id];
    }
    if (isBoolean(data[JoyField.isPublic])) {
        output['isPublic'] = data[JoyField.isPublic];
    }
    if (isBoolean(data[JoyField.likes])) {
        output['like'] = data[JoyField.likes];
    }
    if (isNumber(data[JoyField.limit])) {
        output['limit'] = data[JoyField.limit];
    }
    if (isString(data[JoyField.medium])) {
        output['mediumId'] = data[JoyField.medium];
    }
    if (isJoyFieldMapArray(data[JoyField.mediums])) {
        let media = [];
        for (const mediumData of data[JoyField.mediums]) {
            media.push(toFirestore(mediumData));
        }
        output['media'] = media;
    }
    if (isString(data[JoyField.name])) {
        output['name'] = data[JoyField.name];
    }
    if (isNumber(data[JoyField.offset])) {
        output['offset'] = data[JoyField.offset];
    }
    if (isString(data[JoyField.oldPassword])) {
        output['oldPassword'] = data[JoyField.oldPassword];
    }
    if (isString(data[JoyField.password])) {
        output['password'] = data[JoyField.password];
    }
    if (isString(data[JoyField.phone])) {
        output['phone'] = data[JoyField.phone];
    }
    if (isString(data[JoyField.photoUrl])) {
        output['photoUrl'] = data[JoyField.photoUrl];
    }
    if (isString(data[JoyField.primaryEmail])) {
        output['primaryEmail'] = data[JoyField.primaryEmail];
    }
    if (isJoyPropertiesArray(data[JoyField.props])) {
        let properties = [];
        for (const prop of data[JoyField.props]) {
            properties.push(toFirestoreProperty(prop));
        }
        output['props'] = properties;
    }
    if (isString(data[JoyField.remoteSource])) {
        output['remoteSource'] = data[JoyField.remoteSource];
    }
    if (isString(data[JoyField.remoteToken])) {
        output['remoteToken'] = data[JoyField.remoteToken];
    }
    if (isString(data[JoyField.remoteUri])) {
        output['remoteUri'] = data[JoyField.remoteUri];
    }
    if (isJoyUploadSessionType(data[JoyField.sessionType])) {
        output['sessionType'] = toFirestoreSessionType(data[JoyField.sessionType]);
    }
    if (isString(data[JoyField.text])) {
        output['searchText'] = data[JoyField.text];
    }
    if (isJoyUploadSessionStatusArray(data[JoyField.status])) {
        output['sessionStatuses'] = data[JoyField.status].map((status) => toFirestoreSessionStatus(status));
    }
    if (isStringArray(data[JoyField.users])) {
        output['users'] = data[JoyField.users];
    }
    return output;
}
export function fromFirestoreProperty(property) {
    switch (property) {
        case 'CLIENT':
            return JoyProperty.client;
        case 'PHOTOEDITOR':
            return JoyProperty.photoeditor;
        case 'PHOTOGRAPHER':
            return JoyProperty.photographer;
        case 'PHOTOSESSION':
            return JoyProperty.photosession;
        case 'WATERMARK':
            return JoyProperty.watermark;
    }
}
export function fromFirestoreStatus(status) {
    switch (status) {
        case 'CREATED':
            return JoyStatus.created;
        case 'PROCESSED':
            return JoyStatus.processed;
        case 'DELETED':
            return JoyStatus.deleted;
    }
}
export function fromFirestoreChangeType(changeType) {
    switch (changeType) {
        case 'added':
            return JoyChangeType.added;
        case 'modified':
            return JoyChangeType.modified;
        case 'removed':
            return JoyChangeType.removed;
    }
}
export function fromFirestoreRole(role) {
    switch (role) {
        case 'owner':
            return JoyUserRole.owner;
        case 'subscriber':
            return JoyUserRole.subscriber;
    }
}
export function fromFirestoreCommentType(type) {
    switch (type) {
        case 'audio':
            return JoyCommentType.audio;
        case 'text':
            return JoyCommentType.text;
    }
}
export function fromFirestoreActivityEvent(event) {
    switch (event) {
        case 'ALBUM_CREATED':
            return JoyActivityEvent.albumCreated;
        case 'MEDIA_ADDED_TO_ALBUM':
            return JoyActivityEvent.mediumsAddedToAlbum;
        case 'MEDIA_ADDED_TO_GROUP':
            return JoyActivityEvent.mediumsAddedToGroup;
        case 'COMMENT_ADDED':
            return JoyActivityEvent.commentAded;
        case 'USER_ADDED':
            return JoyActivityEvent.userAdded;
    }
}
export function fromFirestoreDate(map) {
    let seconds = map['_seconds'];
    let nanoseconds = map['_nanoseconds'];
    if (seconds !== null && nanoseconds != null) {
        return new firebase.firestore.Timestamp(seconds, nanoseconds).toDate();
    }
    else {
        return null;
    }
}
export function fromFirestoreSessionType(type) {
    switch (type) {
        case 'ALBUM_CREATED':
            return JoyUploadSessionType.albumCreated;
        case 'MEDIA_ADDED_TO_ALBUM':
            return JoyUploadSessionType.mediumsAddedToAlbum;
        case 'MEDIA_ADDED_TO_GROUP':
            return JoyUploadSessionType.mediumsAddedToGroup;
    }
}
export function fromFirestoreSessionStatus(status) {
    switch (status) {
        case 'started':
            return JoyUploadSessionStatus.started;
        case 'in_progress':
            return JoyUploadSessionStatus.inProgress;
        case 'waiting_processing':
            return JoyUploadSessionStatus.waitingProcessing;
        case 'finished':
            return JoyUploadSessionStatus.finished;
        case 'incomplete':
            return JoyUploadSessionStatus.incomplete;
        case 'error':
            return JoyUploadSessionStatus.error;
    }
}
export function toFirestoreAuthProvider(provider) {
    switch (provider) {
        case JoyAuthServiceAuthProvider.apple:
            return 'APPLE';
        case JoyAuthServiceAuthProvider.google:
            return 'GOOGLE';
    }
}
export function toFirestoreAction(action) {
    switch (action) {
        case JoyDataServiceAction.create:
            return 'create';
        case JoyDataServiceAction.read:
            return 'get';
        case JoyDataServiceAction.update:
            return 'update';
        case JoyDataServiceAction.delete:
            return 'delete';
    }
}
export function toFirestoreUploadAction(action) {
    switch (action) {
        case JoyUploadServiceAction.create:
            return 'create';
        case JoyUploadServiceAction.get:
            return 'get';
        case JoyUploadServiceAction.addMedia:
            return 'update';
        case JoyUploadServiceAction.delete:
            return 'delete';
    }
}
export function toFirestoreFunction(func) {
    switch (func) {
        case JoyCrmIntegrationServiceFunction.userLocation:
            return 'httpsUserLocation';
        case JoyCrmIntegrationServiceFunction.photoClientsSearch:
            return 'httpsGetActiveCampaignClients';
        case JoyCrmIntegrationServiceFunction.sendPublicAlbum:
            return 'httpsSendPublicAlbumUrl';
    }
}
export function toFirestoreObjectType(objectType) {
    switch (objectType) {
        case JoyObjectType.activity:
            return 'activity';
        case JoyObjectType.album:
            return 'album';
        case JoyObjectType.comment:
            return 'comment';
        case JoyObjectType.group:
            return 'group';
        case JoyObjectType.medium:
            return 'media';
        case JoyObjectType.user:
            return 'user';
    }
}
export function toFirestoreSessionType(type) {
    switch (type) {
        case JoyUploadSessionType.albumCreated:
            return 'ALBUM_CREATED';
        case JoyUploadSessionType.mediumsAddedToAlbum:
            return 'MEDIA_ADDED_TO_ALBUM';
        case JoyUploadSessionType.mediumsAddedToGroup:
            return 'MEDIA_ADDED_TO_GROUP';
    }
}
export function toFirestoreSessionStatus(type) {
    switch (type) {
        case JoyUploadSessionStatus.started:
            return 'started';
        case JoyUploadSessionStatus.inProgress:
            return 'in_progress';
        case JoyUploadSessionStatus.waitingProcessing:
            return 'waiting_processing';
        case JoyUploadSessionStatus.finished:
            return 'finished';
        case JoyUploadSessionStatus.incomplete:
            return 'incomplete';
        case JoyUploadSessionStatus.error:
            return 'error';
    }
}
export function toFirestoreRole(role) {
    switch (role) {
        case JoyUserRole.owner:
            return 'owner';
        case JoyUserRole.subscriber:
            return 'subscriber';
    }
}
export function toFirestoreProperty(property) {
    switch (property) {
        case JoyProperty.client:
            return 'CLIENT';
        case JoyProperty.photoeditor:
            return 'PHOTOEDITOR';
        case JoyProperty.photographer:
            return 'PHOTOGRAPHER';
        case JoyProperty.photosession:
            return 'PHOTOSESSION';
        case JoyProperty.watermark:
            return 'WATERMARK';
    }
}
export function toFirestoreStatus(status) {
    switch (status) {
        case JoyStatus.created:
            return 'CREATED';
        case JoyStatus.processed:
            return 'PROCESSED';
        case JoyStatus.deleted:
            return 'DELETED';
    }
}
export function toFirestoreDate(date) {
    let timestamp = firebase.firestore.Timestamp.fromDate(date);
    let map = {};
    map['_seconds'] = timestamp.seconds;
    map['_nanoseconds'] = timestamp.nanoseconds;
    return map;
}
//# sourceMappingURL=FirestoreConversion.js.map